module.exports = __webpack_public_path__ + "static/media/clemazonnn.98e1a47d.png";